import { get, post } from './axios.js'

/**
 * company 목록 조회 - /comp/compList
 * @param {Object} params
 * @property {Number} params.page_count - page 단위
 * @property {Number} params.unit_count - 힌 페이지에 보여줄 cnt
 * @property {string} params.cmp_nm - 회사명
 * @property {string} params.ceo_nm - 대표이름
 * @property {string} params.cmp_dvsn_nm - 부서명
 * @property {string} params.business_no - 사업자등록번호
 * @property {string} params.check_am - Y / null 값이 있으면 AM USER_ID 존재하는 회사만 조회
 * @property {string} params.acc_year - 회계년도
 * @property {string} params.app_dt - 적용일시
 * @returns
 */
export async function compList(params = {}) {
  try {
    const result = await post('/comp/compList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * account 매핑 조회 - /comp/accountCompList
 * @param {Object} params
 * @property {Number} params.page_count - page 단위
 * @property {Number} params.unit_count - 힌 페이지에 보여줄 cnt
 * @property {string} params.cmp_nm - 회사명
 * @property {string} params.ceo_nm - 대표이름
 * @property {string} params.cmp_dvsn_nm - 부서명
 * @property {string} params.business_no - 사업자등록번호
 * @property {string} params.check_am - Y / null 값이 있으면 AM USER_ID 존재하는 회사만 조회
 * @property {string} params.acc_year - 회계년도
 * @property {string} params.app_dt - 적용일시
 * @returns
 */
export async function accountCompList(params = {}) {
  try {
    const result = await post('/comp/accountCompList', params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}


/**
 * 회사분류 체계 조회 - /comp/classList
 * @returns
 */
export async function classList() {
    try {
      const result = await post('/comp/classList', {})
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}

/**
 * 회사분류 체계 등록/수정 - /comp/classEdit
 * @param {Object} params
 * @property {string} params.up_class_id - 회사상위분류코드
 * @property {string} params.class_nm - 회사분류코드명
 * @property {string} params.enable_yn - (비)활성화
 * @property {string} params.note - 메모
 * @property {string} params.sort_ord - 순번
 * @property {string} params.ss_user_id - 로그인 user id
 * @property {string} params.rev_id - rev 버전
 * 
 * @returns
 */
export async function classEdit(params = {}) {
  try {
    const result = await post('/comp/classEdit',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * 회사분류 체계 삭제 - /comp/classDelete
 * @param {Object} params
 * @property {string} params.class_id - 회사분류 자신 코드
 * @property {string} params.rev_id - rev 버전
 * @returns
 */
export async function classDelete(params = {}) {
  try {
    const result = await post('/comp/classDelete',params)
    return result.data
  } catch(e) {
    console.log(e)
    if(e.response.data?.code === '0004') alert(e.response.data.ex_message)
    else alert('삭제에 실패했습니다.')
    throw new Error(e)
  }
}



/**
 * 회사분류 체계 신규 리비전으로 저장 - /comp/classInst
 * @param {Object} params
 * @property {Array} params.companyClassListVO - 저장할 회사분류 체계 리스트
 * @property {string} params.companyClassListVO[index].up_class_id - 회사상위분류코드
 * @property {string} params.companyClassListVO[index].class_id - 회사분류코드
 * @property {string} params.companyClassListVO[index].class_nm - 회사분류코드명
 * @property {string} params.companyClassListVO[index].enable_yn - (비)활성화
 * @property {string} params.companyClassListVO[index].note - 메모
 * @property {string} params.companyClassListVO[index].sort_ord - 순번
 * @property {string} params.companyClassListVO[index].ss_user_id - 로그인 user id
 * @returns
 */
export async function classInst(params = {}) {
    try {
      const result = await post('/comp/classInst',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}




/**
 * 회사분류 체계 이력 조회 - /comp/classHisList
 * @param {Object} params
 * @property {string} params.rev_id - 조회할 리비젼 id 
 * @property {string} params.enable_yn - 활성화 여부 Y/N
 * @property {string} params.up_class_id - 상위코드
 * @returns
 */
export async function classHisList(params = {}) {
    try {
      const result = await post('/comp/classHisList',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 회사분류 체계 리비전 list 조회 - /comp/getRevIdList
 * @returns
 */
export async function getRevIdList() {
    try {
      const result = await post('/comp/getRevIdList', {})
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 회사 등록,수정  - /comp/compEdit
 * @param {Object} params
 * @property {Number} params.cp_seq - 회사 seq(수정일때만 필요)
 * @property {string} params.ss_user_id - 로그인 유저
 * @property {string} params.cmp_nm - 회사명
 * @property {string} params.cmp_dvsn_nm -사업부명
 * @property {string} params.cl_rev_id - 리비전NO
 * @property {string} params.business_no - 사업자등록번호
 * @property {string} params.ceo_nm - 대표자
 * @property {string} params.tel_no -핸드폰번호
 * @property {string} params.fax_no - 팩스번호
 * @property {string} params.homepage - 홈페이지
 * @property {string} params.sector - 업종/업태
 * @property {string} params.enable_yn - (비)활성화
 * @property {string} params.note - 메모
 * @property {string} params.activity - activity
 * @property {string} params.am_user_id - AM USER_ID
 * @property {string} params.tb_id - 테이블id(속성변경시필요)
 * @property {string} params.bkmark_yn - 즐겨찾기(Y:즐겨찾기,N:해제)
 * @property {string} params.address - 주소
 * @property {string} params.address_dtl - 상세 주소 
 * @property {string} params.tmp_yn - 임시저장 Y / N 
 * @returns
 */
export async function compEdit(params = {}) {
    try {
      const result = await post('/comp/compEdit',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 회사 중복체크  - /comp/compCheck
 * @param {Object} params
 * @property {string} params.cmp_nm - 회사명
 * @property {string} params.cmp_dvsn_nm - 부서명
 * @returns
 */
export async function compCheck(params = {}) {
    try {
      const result = await post('/comp/compCheck',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 회사 상세조회  - /comp/compSelect
 * @param {Object} params
 * @property {Number} params.cp_seq - seq
 * @returns
 */
export async function compSelect(params = {}) {
    try {
      const result = await post('/comp/compSelect',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * 회사 관리번호 생성  - /comp/compInfoNextSeq
 * @returns
 */
export async function compInfoNextSeq() {
    try {
      const result = await post('/comp/compInfoNextSeq', {})
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}


/**
 * account 매핑 수정  - /comp/compAccEdit
 * @param {Object} params
 * @property {string} params.cl_rev_id - cl_rev_id
 * @property {string} params.cl_class_id - cl_class_id
 * @property {string} params.am_user_id - am_user_id
 * @property {string} params.sr_user_id - sr_user_id
 * @property {string} params.ss_user_id - ss_user_id
 * @returns
 */
export async function compAccEdit(params = {}) {
    try {
      const result = await post('/comp/compAccEdit',params)
      return result.data
    } catch(e) {
      throw new Error(e)
    }
}

/**
 * account 매핑 수정  - /comp/compAccEdit
 * @param {Object} params
 * @returns
 */
export async function compYearChange(params = {}) {
  try {
    const result = await post('/comp/compYearChange',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}

/**
 * mk회사seq조회 - /comp/MK_SALES_CMP_SEQ
 * @param {Object} params
 * @returns
 */
export async function MkSalesCmpSeq(params = {}) {
  try {
    const result = await post('/comp/MkSalesCmpSeq',params)
    return result.data
  } catch(e) {
    throw new Error(e)
  }
}